/**
 * KunstPfote – „Passt noch nicht ganz?“ im Vorschau-Modal
 *
 * Nach einer Generierung kann der Besucher melden, was am Porträt nicht stimmt (Auswahl + optionaler Text
 * + optionale E-Mail für eine persönliche Antwort). Gesendet wird an den n8n-Workflow „Preview feedback“,
 * der den Eintrag in Airtable (Tabelle „Feedback“) speichert und Sven per Telegram benachrichtigt.
 *
 * Session und Motiv kommen aus dem Event kunstpfote:generation-complete (generation-progress.js).
 * Markup: snippets/generation-progress-modal.liquid
 */
(() => {
  if (customElements.get('kp-preview-feedback')) return;

  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  class KpPreviewFeedback extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-fb-toggle]');
      this.form = this.querySelector('[data-fb-form]');
      this.errorEl = this.querySelector('[data-fb-error]');
      this.doneEl = this.querySelector('[data-fb-done]');
      this.submitBtn = this.querySelector('[data-fb-submit]');
      this.context = null;

      this.toggleBtn?.addEventListener('click', () => this.open(this.form.hidden));
      this.querySelector('[data-fb-cancel]')?.addEventListener('click', () => this.open(false));
      this.form?.addEventListener('submit', (e) => this.submit(e));

      this.onComplete = (e) => {
        const { sku, sessionId } = e.detail || {};
        if (!sku || !sessionId) return;
        this.context = { motiv: sku, sessionId };
        this.reset();
      };
      this.onStarted = () => { this.context = null; this.reset(); };
      window.addEventListener('kunstpfote:generation-complete', this.onComplete);
      window.addEventListener('kunstpfote:generation-started', this.onStarted);
    }

    disconnectedCallback() {
      window.removeEventListener('kunstpfote:generation-complete', this.onComplete);
      window.removeEventListener('kunstpfote:generation-started', this.onStarted);
    }

    reset() {
      this.form?.reset();
      this.open(false);
      if (this.doneEl) this.doneEl.hidden = true;
      if (this.toggleBtn) this.toggleBtn.hidden = !this.context;
      this.showError('');
      if (this.submitBtn) this.submitBtn.disabled = false;
    }

    open(show) {
      if (!this.form || !this.toggleBtn) return;
      this.form.hidden = !show;
      this.toggleBtn.setAttribute('aria-expanded', String(show));
      if (show) {
        requestAnimationFrame(() => {
          this.form.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          this.form.querySelector('input[type="checkbox"]')?.focus({ preventScroll: true });
        });
      }
    }

    showError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = !msg;
    }

    async submit(e) {
      e.preventDefault();
      if (!this.context) return;
      const fd = new FormData(this.form);
      const problems = fd.getAll('problems');
      const text = String(fd.get('text') || '').trim();
      const email = String(fd.get('email') || '').trim();

      if (!problems.length && !text) {
        this.showError('Wähl bitte mindestens einen Punkt aus oder beschreib kurz, was nicht stimmt.');
        return;
      }
      if (email && !EMAIL_RE.test(email)) {
        this.showError('Die E-Mail-Adresse sieht nicht ganz richtig aus.');
        return;
      }
      this.showError('');
      this.submitBtn.disabled = true;

      try {
        const res = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          body: JSON.stringify({
            ...this.context,
            problems,
            text,
            email,
            website: String(fd.get('website') || ''), // Honeypot
            page: location.origin + location.pathname,
          }),
        });
        if (!res.ok) throw new Error(String(res.status));
      } catch (err) {
        this.submitBtn.disabled = false;
        this.showError('Das hat leider nicht geklappt. Schreib mir gern direkt an hallo@kunstpfote.de.');
        return;
      }

      this.form.hidden = true;
      this.toggleBtn.hidden = true;
      if (this.doneEl) {
        this.doneEl.textContent = email
          ? 'Danke dir! Ich schaue mir dein Bild persönlich an und melde mich per E-Mail.'
          : 'Danke dir! Dein Feedback hilft mir, die Porträts genauer zu machen.';
        this.doneEl.hidden = false;
      }
    }
  }

  customElements.define('kp-preview-feedback', KpPreviewFeedback);
})();
